import { Component, Input, OnInit } from '@angular/core';
import { TaskService } from '../../../../services/task.service';
import { WorkflowKeyValuePairService } from '../../../../services/workflow-keyvaluepair.service';
import WorkflowHelper from '../../../../shared/WorkflowHelper';
import { CustomerCampaignService } from '../../../../services/customer-campaign.service';
import { finalize, forkJoin, switchMap } from 'rxjs';

@Component({
  selector: 'app-components-managecustomer-page-optimization-task-details',
  templateUrl: './page-optimization-task-details.component.html'
})
export class PageOptimizationTaskDetailsComponent implements OnInit {
  @Input() taskId: number;

  dfd: JQueryDeferred<void>;
  isLoading = true;
  task: Boo.Objects.Task;
  pageType: string;
  notesForContentWriter: string;
  notesForImplementationSpecialist: string;
  url = '';
  taskTypeTips = '';
  taskTypeName = '';

  constructor(
    private taskService: TaskService,
    private workflowKeyValuePairService: WorkflowKeyValuePairService,
    private customerCampaignService: CustomerCampaignService,
  ) { }

  ngOnInit(): void {
    this.taskService.getById(this.taskId).pipe(
      switchMap(task => {
        this.task = task;
        this.taskTypeName = this.task.TaskTypeSummary.Name;
        this.taskTypeTips = this.task.TaskTypeSummary.Tips || '';
        return forkJoin([
          this.workflowKeyValuePairService.getByTaskId(this.taskId),
          this.customerCampaignService.getWebsiteUrl(task.WebsiteUrlId)
        ]);
      }),
      finalize(() => this.isLoading = false)
    )
      .subscribe({
        next: ([keyValuePairs, websiteUrl]) => {
          this.pageType = WorkflowHelper.get<string>(keyValuePairs, Boo.Objects.Enums.KeyEnum.PageType);
          this.notesForContentWriter = WorkflowHelper.get<string>(keyValuePairs, Boo.Objects.Enums.KeyEnum.NotesForContentWriter);
          this.notesForImplementationSpecialist = WorkflowHelper.get<string>(keyValuePairs, Boo.Objects.Enums.KeyEnum.NotesForImplementationSpecialist);
          this.url = websiteUrl.Url;
        },
        error: err => toastr.error('Failed to load task details:', err)
      });
  }

  cancel(): void {
    if (this.dfd) {
      this.dfd.resolve();
    }
  }
}

